import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Input,
  InputGroup,
  InputRightAddon,
  Icon,
  Stack,
  TableContainer,
  VStack,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FiMonitor } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const PAGE_SIZE = 10;

const betsData = [
  { id: "FPIFH39K", date: "2025-11-20 11:32 AM", user: "@bettaprop", type: "Single", stake: 100.0, return: 235.0, status: "Pending" },
  { id: "676O2BBD", date: "2025-11-19 07:47 AM", user: "@5800900", type: "Single", stake: 100.0, return: 210.0, status: "Pending" },
  { id: "7XM8RXLZ", date: "2025-11-18 03:58 AM", user: "@5800900", type: "Single", stake: 23.0, return: 38.41, status: "Pending" },
  { id: "VDUTC99T", date: "2025-10-08 06:41 AM", user: "@username", type: "Single", stake: 10.0, return: 26.3, status: "Pending" },
  { id: "WMTOYHCQ", date: "2025-10-08 06:41 AM", user: "@username", type: "Single", stake: 10.0, return: 15.3, status: "Pending" },
  { id: "FA3BBJAY", date: "2025-10-07 06:22 AM", user: "@username", type: "Single", stake: 20.0, return: 25.2, status: "Pending" },
  { id: "TUJL9MGW", date: "2025-09-26 07:10 AM", user: "@testuser", type: "Multi", stake: 100.0, return: 13500.0, status: "Pending" },
  { id: "P5YPL3X3", date: "2025-09-23 04:38 AM", user: "@bettaprop", type: "Single", stake: 211.0, return: 251.09, status: "Pending" },
  { id: "A1ZGZB9V", date: "2025-09-21 09:19 PM", user: "@testuser", type: "Single", stake: 20.0, return: 140.0, status: "Pending" },
];

const PendingBets = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const filtered = betsData.filter((b) =>
    b.id.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const data = filtered.slice(start, start + PAGE_SIZE);
  const SIDEBAR_WIDTH = "240px";

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={8}
        bg="gray.50"
        minH="100vh"
        mt="64px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        {/* HEADER */}
        <Flex
          mb={8}
          justify="space-between"
          align={{ base: "stretch", md: "center" }}
          direction={{ base: "column", md: "row" }}
          gap={4}
        >
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="semibold" color="#1a202c">
            Pending Bets
          </Text>

          <InputGroup maxW={{ base: "100%", md: "300px" }} size="md">
            <Input
              bg="white"
              placeholder="Bet ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              borderRight="none"
              _focus={{ borderColor: "#4c1d95", boxShadow: "none" }}
            />
            <InputRightAddon
              bg="#4f46e5"
              cursor="pointer"
              _hover={{ bg: "#4338ca" }}
            >
              <Icon as={SearchIcon} color="white" />
            </InputRightAddon>
          </InputGroup>
        </Flex>

        {/* TABLE SECTION */}
        <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0" display={{ base: "none", md: "block" }}>
          <TableContainer>
            <Table variant="simple">
              <Thead bg="#4f46e5">
                <Tr h="50px">
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" borderTopLeftRadius="lg">Bet ID</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">Bet Placed At</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">User</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">Type</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">Stake Amount</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">Return</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold">Status</Th>
                  <Th color="white" textTransform="none" fontSize="sm" fontWeight="semibold" borderTopRightRadius="lg">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data.map((b) => (
                  <Tr key={b.id} _hover={{ bg: "gray.50" }}>
                    <Td fontSize="sm" color="gray.600">{b.id}</Td>
                    <Td fontSize="sm" color="gray.600">{b.date}</Td>
                    <Td fontSize="sm">
                      <Text color="#3182ce" cursor="pointer" _hover={{ textDecoration: "underline" }}>
                        {b.user}
                      </Text>
                    </Td>
                    <Td>
                      <Badge
                        variant="outline"
                        rounded="full"
                        px={3}
                        py={0.5}
                        textTransform="none"
                        fontSize="xs"
                        colorScheme={b.type === "Single" ? "green" : "purple"}
                      >
                        {b.type}
                      </Badge>
                    </Td>
                    <Td fontSize="sm" fontWeight="semibold" color="gray.700">
                      ${b.stake.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </Td>
                    <Td fontSize="sm" fontWeight="semibold" color="gray.700">
                      ${b.return.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </Td>
                    <Td>
                      <Badge
                        variant="outline"
                        colorScheme="orange"
                        bg="orange.50"
                        rounded="full"
                        px={3}
                        py={0.5}
                        textTransform="none"
                        fontSize="xs"
                        border="1px solid"
                      >
                        Pending
                      </Badge>
                    </Td>
                    <Td>
                      <Button
                        size="sm"
                        variant="outline"
                        colorScheme="blue"
                        leftIcon={<Icon as={FiMonitor} />}
                        px={4}
                        fontSize="xs"
                        _hover={{ bg: "blue.50" }}
                      >
                        Detail
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>

        {/* Mobile View */}
        <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
          {data.map((b) => (
            <Box key={b.id} bg="white" p={4} borderRadius="lg" boxShadow="sm" border="1px solid" borderColor="gray.200">
              <Flex justify="space-between" align="center" mb={3}>
                <Text fontWeight="bold" fontSize="md">#{b.id}</Text>
                <Badge
                  variant="outline"
                  colorScheme="orange"
                  bg="orange.50"
                  rounded="full"
                  px={3}
                  py={0.5}
                  textTransform="none"
                  fontSize="xs"
                  border="1px solid"
                >
                  Pending
                </Badge>
              </Flex>

              <SimpleGrid columns={2} spacing={4} mb={4}>
                <Box>
                  <Text fontSize="xs" color="gray.500">User</Text>
                  <Text fontSize="sm" fontWeight="500" color="blue.500">{b.user}</Text>
                </Box>
                <Box>
                  <Text fontSize="xs" color="gray.500">Date</Text>
                  <Text fontSize="sm" fontWeight="500">{b.date}</Text>
                </Box>
                <Box>
                  <Text fontSize="xs" color="gray.500">Type</Text>
                  <Badge variant="outline" colorScheme={b.type === "Single" ? "green" : "purple"} fontSize="xs" mt={1}>
                    {b.type}
                  </Badge>
                </Box>
                <Box>
                  <Text fontSize="xs" color="gray.500">Stake</Text>
                  <Text fontSize="sm" fontWeight="bold">${b.stake.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
                </Box>
              </SimpleGrid>

              <Flex justify="space-between" align="center" pt={3} borderTop="1px solid" borderColor="gray.100">
                <Box>
                  <Text fontSize="xs" color="gray.500">Return</Text>
                  <Text fontSize="md" fontWeight="bold" color="green.600">${b.return.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
                </Box>
                <Button size="sm" variant="outline" colorScheme="blue" leftIcon={<Icon as={FiMonitor} />}>
                  Detail
                </Button>
              </Flex>
            </Box>
          ))}
        </VStack>

        {/* PAGINATION */}
        <Flex justify="center" mt={8} gap={2}>
          <Button
            size="sm"
            variant="outline"
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            isDisabled={page === 1}
          >
            Prev
          </Button>
          <Flex align="center" px={4}>
            <Text fontSize="sm">
              Page {page} of {totalPages || 1}
            </Text>
          </Flex>
          <Button
            size="sm"
            variant="outline"
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            isDisabled={page === totalPages || totalPages === 0}
          >
            Next
          </Button>
        </Flex>
      </Box>
    </>
  );
};

export default PendingBets;
